// Componente shared: renderizza il blocco "originale" sotto il main text di un
// messaggio o captured_data. Usato in admin (web) e replicato come HTML statico
// nel template PDF (encounterReport.ts). Vedi spec sezioni 3.3, 5.

import { getDirForLang, normalizeLangLabel } from '@audiq/shared';

export interface OriginalTextProps {
  text: string;
  langCode: string | null;
  inverse?: boolean;
}

export function OriginalText({ text, langCode, inverse }: OriginalTextProps) {
  const dir = getDirForLang(langCode);
  const label = normalizeLangLabel(langCode);
  const className = inverse ? 'audiq-original audiq-original--inverse' : 'audiq-original';
  return (
    <div className={className} dir={dir}>
      {label ? <span className="audiq-original__label">{label}</span> : null}
      <span className="audiq-original__text">{text}</span>
    </div>
  );
}
